module.exports = __webpack_public_path__ + "static/img/unactive.3d75281f.png";